import { AuthRole } from '../enums/auth';
import { AuthPermissions } from '../interfaces/auth/permissions';
import { UserDoc } from '../interfaces/database/user';

export class DbUtil {
  static getUserRole(user: UserDoc | undefined): AuthRole {
    if (user?.isAdmin) {
      return AuthRole.Admin;
    }

    if (user?.dealerID) {
      return AuthRole.Dealer;
    }

    if (user?.investorID) {
      return AuthRole.Investor;
    }

    // default
    return AuthRole.User;
  }

  static getUserPermissions(user: UserDoc | undefined): AuthPermissions {
    const role = DbUtil.getUserRole(user);

    switch (role) {
      case AuthRole.Admin: {
        const output: AuthPermissions = {
          accounts: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          custodians: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          dealers: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          investors: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          issuers: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          prices: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          revenueStructures: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          securities: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          transactions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          users: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        };

        return output;
      }

      case AuthRole.Dealer: {
        const output: AuthPermissions = {
          accounts: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          custodians: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          dealers: {
            read: true,
          },
          investors: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          issuers: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          prices: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          revenueStructures: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          securities: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          transactions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          users: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        };

        return output;
      }

      case AuthRole.Investor: {
        const output: AuthPermissions = {
          accounts: {
            read: true,
          },
          transactions: {
            read: true,
          },
        };

        return output;
      }

      default: {
        const output: AuthPermissions = {
          // access to nothing
        };

        return output;
      }
    }
  }
}
